import dayjs from "dayjs";
import { useEffect, useState } from "react";
import styled from "styled-components";
import utc from "dayjs/plugin/utc";
import { formatCurrencyNumberOnly } from "../CurrencyFormat";
dayjs.extend(utc);
const Title = styled.div`
  font-size: 80px;
  color: #1e293b;

  font-weight: 600;
`;

const SmallText = styled.div`
  margin-bottom: 24px;
  margin-top: 24px;
  color: #94a3b8;
  font-size: 25px;
`;

const RatioText = styled(SmallText)`
  margin-bottom: 12px;
  margin-top: 12px;
`;

const UptimeNumber = styled(Title)`
  font-size: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
`;

const Container = styled.div`
  padding: 20px;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

const LeftNumber = styled(Title)`
  font-size: 80px;
  margin-top: 20px;
  margin-bottom: 20px;
  width: 500px;
  text-align: right;
`;

const Logo = styled.img`
  height: 120px;
  width: 360px;
  margin-bottom: 50px;
`;

const Uptime = () => {
  const [planNow, setPlanNow] = useState(dayjs.utc());
  const [confirmedNow, setConfirmNow] = useState(dayjs.utc());

  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null;
    const changeValue = () => {
      setPlanNow(dayjs.utc());

      // Set a random interval between 1000ms (1s) and 3000ms (3s)
      const nextInterval = Math.floor(Math.random() * 1000) + 1000;
      timeout = setTimeout(changeValue, nextInterval);
    };

    // Start the process
    changeValue();

    // Cleanup function to prevent memory leaks
    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, []);

  useEffect(() => {
    const time = setInterval(() => {
      setConfirmNow(dayjs.utc());
    }, 1000);
    return () => {
      clearInterval(time);
    };
  }, []);

  function formatNumber(num: number) {
    // Multiply by 1000 to shift decimal 3 places right
    const shifted = num * 10000;

    // Use Math.floor to truncate (not round) the number
    const truncated = Math.floor(shifted);

    // Divide by 1000 to shift decimal 3 places left
    return truncated / 10000;
  }
  const upTimeRate = `${formatNumber(
    (100 * planNow.valueOf()) / confirmedNow.valueOf()
  ).toFixed(4)}%`;
  console.log(upTimeRate);

  const planValue =
    planNow.diff(dayjs(1696204800000), "second") >
    confirmedNow.diff(dayjs(1696204800000), "second")
      ? confirmedNow.diff(dayjs(1696204800000), "second")
      : planNow.diff(dayjs(1696204800000), "second");
  return (
    <Container>
      <Logo src={`${process.env.PUBLIC_URL}/logo.png`} />

      <Title>Uptime Tracker </Title>
      <SmallText style={{ color: "black" }}>
        Since October 2, 2023 00:00:00 GMT
      </SmallText>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <LeftNumber>{upTimeRate}</LeftNumber>
        <div style={{ margin: "0 50px" }}>
          <UptimeNumber>{" = "}</UptimeNumber>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ width: 400 }}>
            <UptimeNumber style={{ color: "#027cca" }}>
              {formatCurrencyNumberOnly(planValue, "JPY")}
            </UptimeNumber>
            <div style={{ border: "2px solid #1e293b" }}></div>
            <UptimeNumber>
              {formatCurrencyNumberOnly(
                confirmedNow.diff(dayjs(1696204800000), "second"),
                "JPY"
              )}
            </UptimeNumber>
          </div>
          <div style={{ marginLeft: 10 }}></div>
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginTop: 40 }}>
        <SmallText>{"Uptime Rate ="}</SmallText>
        <div style={{ marginLeft: 10 }}></div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <RatioText>Successful Confirmed Blocks</RatioText>
          <div style={{ border: "1px solid #94a3b8", width: "100%" }}></div>
          <RatioText>Planned Confirmed Blocks</RatioText>
        </div>
      </div>
    </Container>
  );
};

export default Uptime;
